/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Delta_FreeInputs */

const en_directory_launch_delta_free = /** @type {(inputs: Directory_Launch_Delta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100% vs last month`)
};

const zh_directory_launch_delta_free = /** @type {(inputs: Directory_Launch_Delta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`较上月 +100%`)
};

/**
* | output |
* | --- |
* | "100% vs last month" |
*
* @param {Directory_Launch_Delta_FreeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_delta_free = /** @type {((inputs?: Directory_Launch_Delta_FreeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Delta_FreeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_delta_free(inputs)
	return zh_directory_launch_delta_free(inputs)
});
export { directory_launch_delta_free as "directory.launch.delta_free" }